export default "__VITE_ASSET__pYukgsLh__"